import { mutation } from "@/services/lukita";
import { gql } from "@urql/core";

export default function generateProjectPromptMutation(
  accountId,
  slug,
  instructions,
) {
  return mutation(
    gql`
      mutation GenerateProjectPromptMutation(
        $input: GenerateProjectPromptInput!
      ) {
        generateProjectPrompt(input: $input) {
          project {
            promptReport
          }
        }
      }
    `,
    { input: { accountId, slug, instructions } },
    { additionalTypenames: ["ProjectRecord"] },
  );
}
